import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import GenerarListPriceFormConfig from "./form";
import { showAlert } from "@utils/Alert";
import { useEffect, useRef, useState } from "react";
import { ListPriceDataType } from "@/formTypes/GenerateListPriceDataType";
import { useAppSelector } from "@/store/hooks";
import { PriceApi } from "@/api/PricesApi";


const GenerarListPriceForm = () => {
  const formRef = useRef<DynamicFormRef>(null);
  const [prices, setPrices] = useState<Record<string, string>>({});
  const suscriptionData = useAppSelector(state => state.suscription.suscription || {})

  useEffect(() => {
    const loadPrices = async () => {
      const priceOptions = await PriceApi.optionsList()
      setPrices(priceOptions)
    }
    loadPrices()
  }, [suscriptionData.id])


  const onSubmit = (formData: ListPriceDataType) => {
    window.open(`/user/reports/list-price/${formData.priceId}/${formData.onlyOnInventory ? "true" : "false"}`, "_blank")
  }

  const getForm = () => {
    const precioIdInput = GenerarListPriceFormConfig.sections.flatMap(s => s.fields).flat().find(f => f.name === "priceId")
    if (precioIdInput) {
      precioIdInput.options = prices
    }
    return GenerarListPriceFormConfig
  }

  return (
    <>
      <DynamicForm<ListPriceDataType>
        ref={formRef}
        formConfig={getForm()}
        onSubmit={onSubmit}
      >
      </DynamicForm>
    </>

  )
}

export default GenerarListPriceForm;